import styled from "styled-components";
export const Container = styled.div `
  align-items: stretch;
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export const Monk = styled.div `
  align-items: center;
  border: 1px solid ${({ theme }) => theme.color.ui4};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: space-between;
  padding: 8px;
  ${({ theme }) => theme.font.t3};
`;
export const MonkGrid = styled.div `
  display: grid;
  gap: 21px;
  grid-template-columns: repeat(5, 1fr);
`;
export const Basic = styled.div `
  display: flex;
  justify-content: center;
`;
export const BasicGrid = styled.div `
  display: flex;
  gap: 20px;
  padding: 8px;
`;
